export default __webpack_public_path__ + "static/media/Group 11818.838f17bc.svg";